// Actions
const UPDATE_NOTIFICATION_STATE =
  'changesync/notifications/UPDATE_NOTIFICATION_STATE';
const HIDE_NOTIFICATION = 'changesync/notifications/HIDE_NOTIFICATION';

// notifications Types: 'primary', 'success', 'danger', 'warning'

// Initial State
const initialState = {
  notification: {
    isShown: false,
    type: 'primary',
    forPath: '',
    message: '',
  },
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_NOTIFICATION_STATE:
      return {
        ...state,
        notification: {
          isShown: action.payload.isShown,
          type: action.payload.type,
          forPath: action.payload.forPath,
          message: action.payload.message,
        },
      };
    case HIDE_NOTIFICATION:
      return {
        ...state,
        notification: {
          ...state.notification,
          isShown: false, // Only change the visibility to false
        },
      };
    default:
      return state;
  }
};

export const updateNotificationState = (notification) => ({
  type: UPDATE_NOTIFICATION_STATE,
  payload: notification,
});

export const updateAutoHiddenNotificationState =
  (notification, delay = 5000) =>
  (dispatch) => {
    dispatch({
      type: UPDATE_NOTIFICATION_STATE,
      payload: notification,
    });

    setTimeout(() => {
      dispatch({
        type: HIDE_NOTIFICATION,
      });
    }, delay);
  };

// Selector

export const selectNotificationState = (state) =>
  state.notifications.notification;
